import { defineMessages } from 'react-intl';

export const variantsMessages = defineMessages({
  unavailable: {
    id: 'pd.variants.tile.unavailable',
    defaultMessage: 'Nedostupné',
  },
});
